import {
    Component,
    ElementRef,
    EventEmitter,
    Input, OnChanges,
    Output, SimpleChanges,
    TemplateRef,
    ViewChild,
    ViewContainerRef
} from '@angular/core';

import { AbstractComponent } from '../../../definition/abstract/abstract.component';
import { SelectorOptionModel } from './model/selector-option.model';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

@Component({
    selector: 'app-selector',
    templateUrl: './selector.component.html',
    styleUrls: ['./selector.component.scss']
})
export class SelectorComponent extends AbstractComponent implements OnChanges {
    @Input() processing = false;
    @Input() options: Array<SelectorOptionModel>;
    @Input() disabledValues: Array<string | number> = [];
    @Input() value?: string | number | null;
    @Input() icon?: string;
    @Input() placeholder?: string = 'Selecione';
    @Input() viewMode = 'menu';
    @Input() label: string = '';
    @Input() small = false;
    @Input() returnType: 'value' | 'all' = 'value';
    @Input() emitFirstValue = true;

    @Output() public changed = new EventEmitter();

    @ViewChild('trigger') trigger!: ElementRef;
    @ViewChild('menuTemplate') menuTemplate!: TemplateRef<any>;


    filteredOptions: Array<SelectorOptionModel>;
    overlayRef!: OverlayRef;
    valueContext: SelectorOptionModel | null;

    constructor(
        private overlay: Overlay,
        private viewContainerRef: ViewContainerRef
    ) {
        super();
    }

    public override ngOnInit(): void {
        if (this.value) {
            this.valueContext = this.options.find((option) => option.value === this.value as string) as SelectorOptionModel;
            if (this.emitFirstValue) {
                this.changed.emit(this.returnType === 'all' ? this.valueContext : this.value);
            }
        }
        this.filteredOptions = [...this.options];
    }
    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['options']) {
            this.filteredOptions = [...this.options];
            const currentValue = this.value;
            if (currentValue !== null && currentValue !== undefined && !this.filteredOptions.some((option) => String(option.value) === String(currentValue))) {
                this.value = null;
                this.valueContext = null;
                this.changed.emit(null);
            }
        }
    }

    public eventOpenOptions(): void {
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo(this.trigger)
            .withPositions([
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'top',
                    offsetY: 8,
                }
            ]);

        const triggerWidth = this.trigger.nativeElement.getBoundingClientRect().width;
        this.overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop: true,
            width: triggerWidth,
            minWidth: triggerWidth,
            backdropClass: 'cdk-overlay-transparent-backdrop',
            scrollStrategy: this.overlay.scrollStrategies.reposition()
        });

        this.overlayRef.backdropClick().subscribe(() => { this.overlayRef.dispose();});

        const menuTemplateBuilt = new TemplatePortal(this.menuTemplate, this.viewContainerRef);

        this.overlayRef.attach(menuTemplateBuilt);
    }

    public eventOptionSelected(option: SelectorOptionModel): void {
        if (String(option.value) === String(this.value)) {
            this.value = null;
            this.valueContext = null;
        } else {
            this.value = option.value;
            this.valueContext = option;
        }
        this.changed.emit(this.returnType === 'all' ? this.valueContext : this.value);

        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
    }

    public eventFilter(event: Event): void {
        const filterValue = (event.target as HTMLInputElement).value;
        if (filterValue) {
            this.filteredOptions = this.options.filter((option: SelectorOptionModel) => {
                return JSON.stringify(option).includes(filterValue);
            });
        } else {
            this.filteredOptions = [...this.options];
        }
    }
}
